import { useMemo } from 'react'

import { Option } from '@joor/design-system'

import { BrandStartOrderIds } from 'modals/OrderList/StartOrderModal/StartOrderModal.ids'

import { getDesignSystemOptionId } from '../../BrandStartOrderModal.formatters'
import messages from '../../BrandStartOrderModal.messages'
import { StyledDropdown } from './PriceTypeDropdown.styles'

interface PriceTypeDropdownProps {
  options: Option[]
  value: string | null | undefined
  setSelectedPriceTypeId: (priceTypeId: string) => void
}

export const PriceTypeDropdown = ({
  options,
  value,
  setSelectedPriceTypeId,
}: PriceTypeDropdownProps) => {
  const selectedOption = useMemo(
    () =>
      options.find((option) => getDesignSystemOptionId(option) === value) ??
      null,
    [options, value],
  )

  const handleSelect = ({ selected }: { selected: Option }) => {
    setSelectedPriceTypeId(getDesignSystemOptionId(selected))
  }

  return (
    <StyledDropdown
      id={BrandStartOrderIds.PriceTypeOptions}
      testId={BrandStartOrderIds.PriceTypeOptions}
      labelId={BrandStartOrderIds.PriceTypeTitle}
      label={messages.selectOrderPriceType}
      options={options}
      value={selectedOption}
      translateOptions={false}
      onSelect={handleSelect}
      placeholder={messages.selectOne}
    />
  )
}
